import { FC, SVGProps } from "react";

const DownIcon: FC<SVGProps<SVGSVGElement>> = (props) => {
  return (
    <svg
      width="16"
      height="16"
      viewBox="0 0 16 16"
      fill="none"
      stroke="currentcolor"
      strokeWidth="1.34"
      strokeLinecap="round"
      strokeLinejoin="round"
      {...props}
    >
      <path d="M4 5L8 9L12 5" transform="translate(0,3)" />
    </svg>
  );
};

export default DownIcon;
